import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { RootState } from '../../presentation/redux/store/RootState';
import { useDispatch, useSelector } from 'react-redux';
import { posMovsComisiones } from '../action/reporte/posMovsComisiones';
import { ReporteComsFiltro } from './ReporteComsFiltro';
import { ReporteComsTabla } from './ReporteComsTabla';
import { ButtonDownloadExcelComponent } from '../csv/ButtonDownloadExcelComponent';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { comsPagoDataToCsv } from './comsPagoDataToCsv';

interface ModalProps {
  isOpen: boolean;
  toggle: Function;
  token: string;
}

export const ModalReporteMovs: React.FC<ModalProps> = (props: ModalProps) => {
  const dispatch = useDispatch();
  const modalState = useSelector((s: RootState) => s.modalMovState);
  const { isOpen, toggle, token } = props;
  const [listMovs, setListMovs] = useState([]);

  const handleSearch = () => {
    dispatch(UIActions.uiLoadActive());
    dispatch(posMovsComisiones(modalState, token, dispatch, setListMovs));
  }

  const closeModal = () => {
    setListMovs([]);
    toggle();
  }

  return (
    <Modal
      onHide={closeModal}
      show={isOpen}
      backdrop="static"
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton className='gradientBlue colorWhite'>
        <Modal.Title id="contained-modal-title-vcenter">
          Reporte Comisiones Pago de Servicio
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='p-2 bg-light'>
        <ReporteComsFiltro />
        <ReporteComsTabla
          listMovs={listMovs}
        />
      </Modal.Body>
      <Modal.Footer className='bg-light'>
        <button onClick={closeModal} className="btn btn-light btn-outline-secondary float-right">Cerrar</button>
          <div className={`align-self-end ${listMovs.length > 0 ? '': 'btn-disabled'}`}>
            <ButtonDownloadExcelComponent
              className='btn btn-primary float-right'
              csvData={comsPagoDataToCsv(listMovs)}
              fileName={'ReporteComsPagoServicios.csv'} />
          </div>
        <button onClick={handleSearch} className="btn btn-primary float-right" type="submit">Buscar</button>
      </Modal.Footer>
    </Modal >
  )
}